import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Caja } from "@/shared/types/caja";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CajasQuery extends BaseQuery {
    nombre?: string,
}

export async function getAllCajas(query?: CajasQuery): Promise<QueryResponse<Caja>> {
    await sleep(1000);
    const response = await api.get("cajas", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajasQuery(query: CajasQuery = {}, queryConfig: QueryConfig<QueryResponse<Caja>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajas(query),
        queryKey: ["cajas", query],
    })
}

export interface GetAllCajaQueryProps {
    query?: CajasQuery,
    queryConfig?: QueryConfig<QueryResponse<Caja>>,
    children: (queryResult: QueryResult<QueryResponse<Caja>>) => ReactNode
}

export function GetAllCajasQuery({
    query,
    queryConfig,
    children
}: GetAllCajaQueryProps) {
    const queryResult = useGetAllCajasQuery(query, queryConfig);
    return children && children(queryResult);
}